import { FC, Fragment } from "react";
import { useAsync } from "react-use";
import { client } from "../../Rsvp.client";
import { Controller } from "react-hook-form";
import classNames from "classnames";

export const RsvpFormName: FC = () => {
  const { loading, value = [] } = useAsync(async () => {
    const guestsRequest = client.entry.getMany({
      query: {
        limit: 100,
        order: "fields.title",
        content_type: "guest",
      },
    });
    const responsesRequest = client.entry.getMany({
      query: {
        limit: 100,
        content_type: "response",
      },
    });
    const [{ items: guests }, { items: responses }] = await Promise.all([
      guestsRequest,
      responsesRequest,
    ]);
    const excluded = responses.map(
      ({ fields }) => fields?.guest["en-US"].sys.id
    );
    return guests.filter(({ sys: { id } }) => !excluded.includes(id));
  });

  return (
    <Fragment>
      <Controller
        name="guest"
        rules={{
          required: true,
        }}
        render={({
          field: { value: v, onChange, onBlur },
          fieldState: { invalid },
          formState: { isSubmitting },
        }) => {
          return (
            <div className="form-floating">
              <select
                onChange={onChange}
                onBlur={onBlur}
                disabled={loading || isSubmitting}
                className={classNames("form-select", {
                  "is-invalid": invalid,
                })}
                aria-label="Number of guests"
                name="Number of Guests"
                id="num_guests"
              >
                <option value={undefined}>-- Make selection --</option>
                {value.map(({ sys: { id }, fields: { title } }) => {
                  return (
                    <option key={id} value={id}>
                      {title["en-US"]}
                    </option>
                  );
                })}
              </select>
              <label htmlFor="num_guests">Your name*</label>
            </div>
          );
        }}
      />
    </Fragment>
  );
};
